import React, { FunctionComponent, useState } from "react";

import {
  Fade,
  FormControl,
  FormControlLabel,
  FormLabel,
  LinearProgress,
  Radio,
  RadioGroup
} from "@material-ui/core";

import Modal from "./modal";
import { DoorToOpen, Store } from "../../models/Store";
import { isOk } from "../../result";

import * as StoreApi from "../../api/storeApi";
import Alert from "@material-ui/lab/Alert";
import { useDispatch } from "react-redux";
import { updateUserLocation } from "../../store/userLocation/actions";
import moment from "moment";
import { useI18n } from "../../hooks/useI18n";

interface State {
  modalVisible: boolean;
  doorToOpen: DoorToOpen;
  loading: boolean;
  error: boolean;
}

interface Props {
  visible: boolean;
  store?: Store;
  onCancel: () => void;
  isSuccessHandler?: Function;
}

export const DoorOpenModal: FunctionComponent<Props> = ({
  visible,
  store,
  onCancel,
  isSuccessHandler
}) => {
  const dispatch = useDispatch();
  const { t } = useI18n();

  const [state, setState] = useState<State>({
    doorToOpen: DoorToOpen.Entrance,
    loading: false,
    modalVisible: false,
    error: false
  });

  const handleOpenDoor = async (): Promise<boolean> => {
    if (!store || !state.doorToOpen) {
      return true;
    }

    setState({ ...state, loading: true });

    const result = await StoreApi.openDoor(store?.id, state.doorToOpen);

    const success = isOk(result);

    setState({
      ...state,
      error: !success,
      loading: false
    });

    // if (success) {
    dispatch(
      updateUserLocation({
        storeId: store.id,
        storeName: store.name,
        updated: moment().toDate(),
        showReminder: false
      })
    );
    // }

    if (isSuccessHandler) isSuccessHandler(success);

    return true;
  };

  const renderStorageDoor1 = () => {
    const config = JSON.stringify(store?.config);

    if (config === undefined) {
      return <></>;
    }

    if (config.includes("storageDoor1")) {
      return (
        <FormControlLabel
          value="StorageDoor1"
          control={<Radio />}
          label={t("common.formFields.storageDoor1")}
        />
      );
    }
  };

  const renderStorageDoor2 = () => {
    const config = JSON.stringify(store?.config);

    if (config === undefined) {
      return <></>;
    }

    if (config.includes("storageDoor2")) {
      return (
        <FormControlLabel
          value="StorageDoor2"
          control={<Radio />}
          label={t("common.formFields.storageDoor2")}
        />
      );
    }
  };

  const handleChange = (event: any) => {
    setState({ ...state, error: false, doorToOpen: event.target.value });
  };

  return (
    <Modal
      title={`Open door in ${store?.name}`}
      open={visible}
      actions={[
        {
          text: "Ok",
          type: "ok",
          action: handleOpenDoor
        },
        {
          text: "Cancel",
          type: "cancel",
          action: () => {
            setState({ ...state, error: false });
            onCancel();
          }
        }
      ]}
    >
      <FormControl component="fieldset">
        <FormLabel component="legend">
          {t("common.actions.chooseDoor")}
        </FormLabel>
        <RadioGroup
          aria-label={t("common.tooltip.door")}
          name="door"
          value={state.doorToOpen}
          onChange={handleChange}
        >
          <FormControlLabel
            value="Entrance"
            control={<Radio />}
            label={t("common.formFields.entrance")}
          />
          {renderStorageDoor1()}
          {renderStorageDoor2()}
        </RadioGroup>
      </FormControl>
      <Fade
        in={state.loading}
        style={{ transitionDelay: state.loading ? "800ms" : "0ms" }}
      >
        <LinearProgress />
      </Fade>
      <div>
        {!state.loading && state.error && (
          <Alert severity="error">
            {t("common.messages.failedToOpenDoor")}
          </Alert>
        )}
      </div>
    </Modal>
  );
};
